import { HStack, Select } from '@chakra-ui/react';
import React from 'react';

interface MonthYearPickerProps {
  month: number;
  year: number;
  onMonthChange: (month: number) => void;
  onYearChange: (year: number) => void;
}

const months = [
  { value: 1, label: 'Styczeń' },
  { value: 2, label: 'Luty' },
  { value: 3, label: 'Marzec' },
  { value: 4, label: 'Kwiecień' },
  { value: 5, label: 'Maj' },
  { value: 6, label: 'Czerwiec' },
  { value: 7, label: 'Lipiec' },
  { value: 8, label: 'Sierpień' },
  { value: 9, label: 'Wrzesień' },
  { value: 10, label: 'Październik' },
  { value: 11, label: 'Listopad' },
  { value: 12, label: 'Grudzień' },
];

export const MonthYearPicker: React.FC<MonthYearPickerProps> = ({
  month,
  year,
  onMonthChange,
  onYearChange,
}) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

  return (
    <HStack spacing={4}>
      <Select value={month} onChange={(e) => onMonthChange(Number(e.target.value))} width="200px">
        {months.map((m) => (
          <option
            key={m.value}
            value={m.value}
            style={{ color: 'black', backgroundColor: 'white' }}
          >
            {m.label}
          </option>
        ))}
      </Select>
      <Select value={year} onChange={(e) => onYearChange(Number(e.target.value))} width="120px">
        {years.map((y) => (
          <option key={y} value={y} style={{ color: 'black', backgroundColor: 'white' }}>
            {y}
          </option>
        ))}
      </Select>
    </HStack>
  );
};
